import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import assetify from "@quintype/framework/assetify";
import PropTypes from "prop-types";

import { ClientSideOnly, ResponsiveImage } from "@quintype/components";

import humanizeDate from "../../utils/time-format";
import { TwitterSmall } from "../../basic/icons/twitter";
import User from "../../basic/images/user.svg";
import "./styles.m.css";

const AuthorAvatarServerTemplate = ({ name }) => <img src={`${assetify(User)}`} alt="user" />;
AuthorAvatarServerTemplate.propTypes = {
  name: PropTypes.string
};

const AuthorAvatar = ({ author }) => {
  const name = author.name;
  const avatarURL = author["avatar-s3-key"];
  const authorAvatarUrl = author["avatar-url"];
  const storyObj = {
    "hero-image-s3-key": avatarURL,
    "hero-image-metadata": "",
    "hero-image-caption": "Author",
    alt: name
  };

  let imageView = null;

  if (avatarURL) {
    imageView = (
      <ResponsiveImage styleName="author-img" slug={storyObj["hero-image-s3-key"]} aspectRatio={[1, 1]} alt={name} />
    );
  } else if (authorAvatarUrl) {
    imageView = <img styleName="author-img" src={authorAvatarUrl} alt={name} />;
  } else {
    imageView = <img src={`${assetify(User)}`} alt="user" />;
  }

  return <ClientSideOnly serverComponent={AuthorAvatarServerTemplate}>{imageView}</ClientSideOnly>;
};

AuthorAvatar.propTypes = {
  author: PropTypes.object
};

function AuthorDetailsBase({ author, storyFirstPublishedDate, publisherAttributes, storyLastPublishedDate }) {
  const langClassName = publisherAttributes.lang === "ur" ? "urdu-author-avatar" : "author-avatar";
  return (
    <React.Fragment>
      <div styleName="author">
        <div styleName={langClassName}>
          <AuthorAvatar author={author} />
        </div>
        <div>
          <h4 styleName="author-name">
            <a href={`/author/${author.id}/${author.slug}`}>{author.name}</a>
            {author.twitter && (
              <a
                href={`http://twitter.com/${author.twitter}`}
                styleName="twitter-share"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterSmall color="#797979" />
              </a>
            )}
          </h4>
          <time styleName="story-published-date">
            <span className="published-time">
              {" "}
              {storyFirstPublishedDate === storyLastPublishedDate
                ? `Published: ${humanizeDate(storyFirstPublishedDate)}`
                : `Updated: ${humanizeDate(storyLastPublishedDate)}`}
            </span>
          </time>
        </div>
      </div>
    </React.Fragment>
  );
}
AuthorDetailsBase.propTypes = {
  author: PropTypes.object,
  storyFirstPublishedDate: PropTypes.number,
  storyLastPublishedDate: PropTypes.number,
  name: PropTypes.string,
  publisherAttributes: PropTypes.object
};
function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const AuthorDetails = connect(
  mapStateToProps,
  null
)(AuthorDetailsBase);
